<template>
  <div class="task-manage-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="page-title">
        <i class="el-icon-s-cooperation"></i>
        <h2>任务管理</h2>
      </div>
    </div>

    <!-- 统计卡片 -->
    <el-row :gutter="16" class="stat-row">
      <el-col :span="8">
        <div class="stat-card">
          <div class="stat-icon" style="background: rgba(64,158,255,0.1); color: #409EFF;">
            <i class="el-icon-s-cooperation"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ tasks.length }}</div>
            <div class="stat-label">总任务数</div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="stat-card">
          <div class="stat-icon" style="background: rgba(103,194,58,0.1); color: #67C23A;">
            <i class="el-icon-check"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ enabledCount }}</div>
            <div class="stat-label">启用中</div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="stat-card">
          <div class="stat-icon" style="background: rgba(230,162,60,0.1); color: #E6A23C;">
            <i class="el-icon-box"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ archivedCount }}</div>
            <div class="stat-label">已归档</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 搜索与筛选 -->
    <div class="filter-bar">
      <el-input
        v-model="searchQuery"
        placeholder="搜索任务名称"
        prefix-icon="el-icon-search"
        size="small"
        clearable
        style="width: 260px;"
      />
      <el-select v-model="statusFilter" placeholder="状态筛选" size="small" clearable style="width: 140px;">
        <el-option label="全部" value="" />
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="2" />
        <el-option label="归档" :value="3" />
      </el-select>
      <el-button type="primary" size="small" @click="openCreateDialog">
        <i class="el-icon-plus"></i> 新建任务
      </el-button>
    </div>

    <!-- 任务表格 -->
    <el-card class="table-card" shadow="never">
      <el-table :data="filteredTasks" style="width: 100%" v-loading="loading">
        <el-table-column prop="task_name" label="任务名称" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="task-name task-link" @click="enterTask(scope.row)">
              {{ scope.row.task_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="text-muted">{{ scope.row.description || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="statusType(scope.row.status, scope.row)" size="small">
              {{ statusText(scope.row.status, scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="start_date" label="开始时间" width="120">
          <template slot-scope="scope">
            <span class="text-muted">{{ scope.row.start_date || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="end_date" label="截止时间" width="120">
          <template slot-scope="scope">
            <span class="text-muted">{{ scope.row.end_date || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="120">
          <template slot-scope="scope">
            <span class="text-muted">{{ formatDateOnly(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <div class="action-btns">
              <el-button
                v-if="scope.row.status !== 3"
                type="text"
                size="small"
                class="btn-edit"
                @click="openEditDialog(scope.row)"
              >
                编辑
              </el-button>
              <el-dropdown v-if="scope.row.status !== 3" trigger="click" size="small">
                <el-button type="text" size="small" style="color: var(--color-text-secondary);">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.status === 1" @click.native="toggleStatus(scope.row, 2)">
                    <span style="color: #E6A23C;">禁用</span>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status === 2" @click.native="toggleStatus(scope.row, 1)">
                    <span style="color: #67C23A;">启用</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="archiveTask(scope.row)">
                    <span style="color: #909399;">归档</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="confirmDelete(scope.row)">
                    <span style="color: #F56C6C;">删除</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown v-if="scope.row.status === 3" trigger="click" size="small">
                <el-button type="text" size="small" style="color: var(--color-text-secondary);">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toggleStatus(scope.row, 1)">
                    <span style="color: #67C23A;">重新激活</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑任务弹窗 -->
    <el-dialog
      :title="isEdit ? '编辑任务' : '新建任务'"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="任务名称" prop="task_name">
          <el-input v-model="form.task_name" placeholder="请输入任务名称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            placeholder="请输入任务描述（选填）"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="form.start_date"
            type="date"
            placeholder="选择开始日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="截止时间">
          <el-date-picker
            v-model="form.end_date"
            type="date"
            placeholder="选择截止日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="分配管理员">
          <el-select
            v-model="form.assigned_admin_ids"
            multiple
            placeholder="选择管理员（可选）"
            style="width: 100%;"
          >
            <el-option
              v-for="admin in availableAdmins"
              :key="admin.admin_id"
              :label="`${admin.real_name} (${admin.email})`"
              :value="admin.admin_id"
            />
          </el-select>
          <div class="form-hint">分配后，这些管理员可在任务层内管理该任务</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveTask">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TaskManage',
  data() {
    return {
      loading: false,
      searchQuery: '',
      statusFilter: '',
      dialogVisible: false,
      isEdit: false,
      saving: false,
      form: {
        task_id: null,
        task_name: '',
        description: '',
        start_date: '',
        end_date: '',
        assigned_admin_ids: []
      },
      rules: {
        task_name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    tasks() {
      return this.$store.state.tasks.tasksList || []
    },
    enabledCount() {
      return this.tasks.filter(t => t.status === 1).length
    },
    archivedCount() {
      return this.tasks.filter(t => t.status === 3).length
    },
    availableAdmins() {
      return (this.$store.state.admins.admins || []).filter(a => a.role === 'admin' && a.status === 1)
    },
    filteredTasks() {
      let list = [...this.tasks]
      if (this.searchQuery.trim()) {
        const q = this.searchQuery.trim().toLowerCase()
        list = list.filter(t => (t.task_name || '').toLowerCase().includes(q))
      }
      if (this.statusFilter !== '' && this.statusFilter !== null) {
        list = list.filter(t => t.status === this.statusFilter)
      }
      return list
    }
  },
  methods: {
    formatDateOnly(value) {
      if (!value) return '-'
      const text = String(value)
      return text.slice(0, 10)
    },
    enterTask(task) {
      if (task.status === 3) {
        this.$message.warning('归档任务只读，无法进入管理界面')
        return
      }
      this.$store.dispatch('switchTask', task.task_id).then(() => {
        this.$router.push(`/admin/tasks/${task.task_id}/employees`)
      })
    },
    isTaskExpired(row) {
      if (!row.end_date) return false
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const end = new Date(row.end_date)
      end.setHours(0, 0, 0, 0)
      return today > end
    },
    statusType(status, row) {
      if (row && this.isTaskExpired(row)) return 'danger'
      const map = { 1: 'success', 2: 'info', 3: 'warning' }
      return map[status] || 'info'
    },
    statusText(status, row) {
      if (row && this.isTaskExpired(row)) return '已过期'
      const map = { 1: '启用', 2: '禁用', 3: '归档' }
      return map[status] || '未知'
    },
    openCreateDialog() {
      this.isEdit = false
      this.resetForm()
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.isEdit = true
      this.form = {
        task_id: row.task_id,
        task_name: row.task_name,
        description: row.description || '',
        start_date: row.start_date || '',
        end_date: row.end_date || '',
        assigned_admin_ids: this.getAssignedAdminIds(row.task_id)
      }
      this.dialogVisible = true
    },
    getAssignedAdminIds(taskId) {
      const admins = this.$store.state.admins.admins || []
      return admins.filter(a => (a.task_ids || []).includes(taskId)).map(a => a.admin_id)
    },
    resetForm() {
      this.form = {
        task_id: null,
        task_name: '',
        description: '',
        start_date: '',
        end_date: '',
        assigned_admin_ids: []
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async saveTask() {
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return
      this.saving = true
      try {
        if (this.isEdit) {
          const found = this.tasks.find(t => t.task_id === this.form.task_id)
          const updated = {
            task_id: this.form.task_id,
            task_name: this.form.task_name,
            description: this.form.description,
            start_date: this.form.start_date,
            end_date: this.form.end_date,
            status: found ? found.status : 1,
            created_at: (found && found.created_at) || new Date().toISOString().split('T')[0]
          }
          await this.$api.updateTask(this.form.task_id, updated)
          this.$store.commit('UPDATE_TASK', updated)
          // 更新管理员分配
          this.updateAdminAssignments(this.form.task_id, this.form.assigned_admin_ids)
          this.$message.success('任务已更新')
        } else {
          const res = await this.$api.createTask({
            task_name: this.form.task_name,
            description: this.form.description,
            start_date: this.form.start_date,
            end_date: this.form.end_date,
            status: 1
          })
          const newTask = {
            task_id: res.data.task_id,
            task_name: this.form.task_name,
            description: this.form.description,
            start_date: this.form.start_date,
            end_date: this.form.end_date,
            status: 1,
            created_at: new Date().toISOString().split('T')[0]
          }
          this.$store.commit('ADD_TASK', newTask)
          // 更新管理员分配
          this.updateAdminAssignments(newTask.task_id, this.form.assigned_admin_ids)
          this.$message.success('任务已创建')
        }
        this.dialogVisible = false
      } catch (e) {
        this.$message.error('保存失败: ' + ((e.response && e.response.data && e.response.data.message) || e.message))
      } finally {
        this.saving = false
      }
    },
    updateAdminAssignments(taskId, adminIds) {
      const allAdmins = this.$store.state.admins.admins || []
      allAdmins.forEach(admin => {
        const hasTask = (admin.task_ids || []).includes(taskId)
        const shouldHave = adminIds.includes(admin.admin_id)
        if (hasTask && !shouldHave) {
          // 移除
          const updated = {
            ...admin,
            task_ids: (admin.task_ids || []).filter(id => id !== taskId)
          }
          this.$store.commit('UPDATE_ADMIN', updated)
        } else if (!hasTask && shouldHave) {
          // 添加
          const updated = {
            ...admin,
            task_ids: [...(admin.task_ids || []), taskId]
          }
          this.$store.commit('UPDATE_ADMIN', updated)
        }
      })
    },
    async toggleStatus(row, targetStatus) {
      const action = targetStatus === 1 ? '启用' : '禁用'
      try {
        await this.$confirm(`确认${action}任务「${row.task_name}」？`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await this.$api.updateTask(row.task_id, { ...row, status: targetStatus })
        const updated = { ...row, status: targetStatus }
        this.$store.commit('UPDATE_TASK', updated)
        this.$message.success(`任务已${action}`)
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(`${action}失败: ` + ((e.response && e.response.data && e.response.data.message) || e.message))
        }
      }
    },
    async archiveTask(row) {
      try {
        await this.$confirm(`归档后任务将变为只读，确认归档「${row.task_name}」？`, '归档确认', {
          confirmButtonText: '确认归档',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await this.$api.updateTask(row.task_id, { ...row, status: 3 })
        const updated = { ...row, status: 3 }
        this.$store.commit('UPDATE_TASK', updated)
        this.$message.success('任务已归档')
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('归档失败: ' + ((e.response && e.response.data && e.response.data.message) || e.message))
        }
      }
    },
    async confirmDelete(row) {
      try {
        await this.$confirm(`删除后不可恢复，确认删除「${row.task_name}」？`, '删除确认', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'danger'
        })
        await this.$api.deleteTask(row.task_id)
        this.$store.commit('DELETE_TASK', row.task_id)
        this.$message.success('任务已删除')
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败: ' + ((e.response && e.response.data && e.response.data.message) || e.message))
        }
      }
    }
  }
}
</script>

<style scoped>
.task-manage-page {
  padding: var(--space-lg);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-xl);
}

.page-title {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.page-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text);
}

.page-title i {
  font-size: 22px;
  color: var(--color-primary);
}

.stat-row {
  margin-bottom: var(--space-xl);
}

.stat-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  display: flex;
  align-items: center;
  gap: var(--space-md);
  transition: box-shadow 0.2s;
}

.stat-card:hover {
  box-shadow: var(--shadow-md);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.2;
}

.stat-label {
  font-size: 13px;
  color: var(--color-text-muted);
  margin-top: 2px;
}

.filter-bar {
  display: flex;
  gap: var(--space-md);
  margin-bottom: var(--space-lg);
  align-items: center;
}

.table-card {
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
}

.task-name {
  font-weight: 600;
  color: var(--color-text);
}

.task-link {
  color: var(--color-primary);
  cursor: pointer;
  transition: color 0.2s;
}

.task-link:hover {
  color: #D4A72E;
  text-decoration: underline;
}

.text-muted {
  color: var(--color-text-secondary);
  font-size: 13px;
}

.module-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
}

.action-btns {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.action-btns .el-button {
  padding: 0;
  font-size: 13px;
}

.btn-edit {
  color: var(--color-primary) !important;
}

.btn-success {
  color: #67C23A !important;
}

.btn-warning {
  color: #E6A23C !important;
}

.btn-archive {
  color: #909399 !important;
}

.btn-danger {
  color: #F56C6C !important;
}

.form-hint {
  font-size: 12px;
  color: var(--color-text-muted);
  margin-top: 4px;
}
</style>
